import React from "react";

const TimerPopperIcon = ({ width, height, styles }) => (
  <svg
    width={width}
    height={height}
    styles={styles}
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="21" height="21" rx="4" fill="#40E5A0" />
    <path
      d="M14.875 11.125C14.875 13.54 12.915 15.5 10.5 15.5C8.085 15.5 6.125 13.54 6.125 11.125C6.125 8.71 8.085 6.75 10.5 6.75C12.915 6.75 14.875 8.71 14.875 11.125Z"
      stroke="#EFF1F5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 8.49988V10.9999"
      stroke="#EFF1F5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 5.49988H12"
      stroke="#EFF1F5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TimerPopperIcon;
